import './src/com-calendar.js';
export { CALENDAR_TYPE } from './src/com-calendar-behavior.js';

/** export calendar behavior */
import { COMCalendarBehavior } from './src/com-calendar-behavior.js';
export { COMCalendarBehavior };